@if (label()) {
  <h3 class="content-block__label" [id]="labelId">
    @if (icon()) {
      <i class="aw-2-icn" aria-hidden="true" [awIcon]="icon()"></i>
    }
    {{ label() }}
  </h3>
}
<div class="content-block__card" role="group" [attr.aria-labelledby]="labelledBy()">
  <ng-content />
</div>
